import styled, { css } from 'styled-components';
import { Image } from 'app/shared/components/Image/Image';
import { media } from 'app/styles/variables';
import { dimensions } from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/components/FullScreenGallery/FullScreenGallery.css';

interface IImageGalleryStProps {
  selected?: boolean;
  offset?: number;
}

export const ImageGalleryItemSt = styled(Image)<IImageGalleryStProps>`
  max-width: ${dimensions.mobile.width}px;
  background: black;
  border: solid ${({ selected }) => (selected ? '2px' : '0')} white;
  transition: transform 0.3s;
  transform: ${({ offset }) =>
    `translate(calc(${offset * 100 * -1}% - ${offset * 16}px), 0) `};
  min-width: 80px;
  max-width: auto;
  max-height: 100%;
  object-fit: contain;
  ${media.sm(css<IImageGalleryStProps>`
    transform: ${({ offset }) =>
      `translate(0, calc(${offset * 100 * -1}% - ${offset * 16}px)) `};
    min-height: 80px;
    max-width: 100%;
    max-height: auto;
  `)}
  &:hover {
    cursor: pointer;
  }
`;
